export const STYLES = { inline: "inline", multiline: "multiline" };

export const SIZES = { small: "small", medium: "medium" };

export const DEFAULT_TRUNCATE_AT = 3;
